import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ArticlesService } from 'src/app/services/articles/articles.service';

import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';
import { ImageService } from 'src/app/services/image/image.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';

@Component({
  selector: 'app-artical',
  templateUrl: './artical.component.html',
  styleUrls: ['./artical.component.css'],
})
export class ArticalComponent implements OnInit {
  userLang: any = '';

  articles: any = [];
  constructor(
    private router: Router,
    private articleService: ArticlesService,
    private localizationService: LocalizationService,
    private translate: TranslateService,
    private imageService: ImageService,
  ) {
    this.userLang = this.localizationService.getUserLang();
  }

  ngOnInit(): void {
    this.articleService.getArticles().subscribe({
      next: (res: any) => {
        this.articles = res?.length > 8 ? res.slice(0, 8) : res;
      },
      error: (err) => console.error(err),
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLang = event.lang;
    });
  }
  // loadContent(currentLang: string): void {
  //   const langMap: Record<string, string> = {
  //     en: 'english',
  //     ar: 'arabic',
  //   };

  //   const mappedLang = langMap[currentLang] || 'english';
  //   this.content.getAllArticlesTranslation().subscribe({
  //     next: (data: any) => {
  //       this.articles = data?.filter(
  //         (item: any) => item.language === mappedLang
  //       );
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // }
  getFullImageUrl(relativeUrl: string): string {
    let imageUrl = this.imageService.getArticleImagePath(relativeUrl);
    return this.imageService.handleImageUrl(imageUrl);
  }
  // articles = [
  //   {
  //     id: 1,
  //     imageUrl: 'assets/img/Frame 2095587743.png',
  //     date: '20 Sep 2025',
  //     title: 'How to Build a Strong Resume',
  //     points: [
  //       'Highlight your key skills',
  //       'Focus on measurable achievements',
  //       'Keep formatting clean and simple',
  //     ],
  //   },
  //   {
  //     id: 2,
  //     imageUrl: 'assets/img/Frame 2095587744.png',
  //     date: '18 Sep 2025',
  //     title: 'Top Interview Tips',
  //     points: [
  //       'Research the company',
  //       'Prepare STAR answers',
  //       'Dress professionally',
  //     ],
  //   },
  //   {
  //     id: 3,
  //     imageUrl: 'assets/img/Frame 2095587745.png',
  //     date: '15 Sep 2025',
  //     title: 'Boost Your Career Growth',
  //     points: [
  //       'Network strategically',
  //       'Keep learning new skills',
  //       'Find a mentor',
  //     ],
  //   },
  //   {
  //     imageUrl: 'assets/img/Frame 2095587743.png',
  //     date: '10 Sep 2025',
  //     title: 'Time Management Hacks',
  //     points: [
  //       'Prioritize important tasks',
  //       'Use time-blocking',
  //       'Avoid multitasking',
  //     ],
  //   },
  //   {
  //     imageUrl: 'assets/img/Frame 2095587743.png',
  //     date: '05 Sep 2025',
  //     title: 'Remote Work Best Practices',
  //     points: [
  //       'Set up a productive workspace',
  //       'Stick to routines',
  //       'Communicate proactively',
  //     ],
  //   },
  //   {
  //     imageUrl: 'assets/img/Frame 2095587745.png',
  //     date: '15 Sep 2025',
  //     title: 'Boost Your Career Growth',
  //     points: [
  //       'Network strategically',
  //       'Keep learning new skills',
  //       'Find a mentor',
  //     ],
  //   },
  // ];
  // constructor(private router: Router) {}

  goToDetails(id?: number) {
    if (id !== undefined) {
      this.router.navigate(['/articleDetails', id]);
    }
  }
  loadArticleContent(article: any): string {
    if (!article) return '';

    const translation = article.translations?.find(
      (t: any) => t.languageCode === this.userLang,
    );

    return translation?.title || article.title;
  }
  loadArticleDesc(article: any): string {
    if (!article) return '';
    const translation = article.translations?.find(
      (t: any) => t.languageCode === this.userLang,
    );
    return translation?.subtitle || article.subtitle || '';
  }
}
